import {ToastContainer} from "react-toastify";

function ToastHandle() {
    return (
        <ToastContainer     
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={true}
            rtl={true}
            pauseOnFocusLoss={true}
            draggable={false}
            pauseOnHover={false}
        />
    );
};
export default ToastHandle;